export const locale = {
    lang: 'en',
    data: {
        LANDING_PAGE: {
            TITLES: {
                MAIN: 'There’s no place like home...',
                DONT_MISS_OUT_YOUR_DREAM: 'Don\’t miss out on your dream home!',
                DOWNLOAD_MOBILE_APP: 'Download the mobile app and find your place today.'
            }
        }
    }
};